import identify from "~/identify";

const modes = ['edit', 'view'];

const lexModelPathName = (pathName) => {
    let parts = pathName
        .toLowerCase()
        .split('/')
        .slice(1);


    const assertModelName = (modelNameSuspect) => {
        if(!modelNameSuspect.match(/(\w|[-_])+/)) {
            throw new Error('Expected path, got '+modelNameSuspect);
        }
    };

    const assertItemId = (modelIdSuspect) => {
        if(!modelIdSuspect.match(/(\d+)|(new)/)) {
            throw new Error('Expected model id, got '+modelIdSuspect);
        }
    };

    const assertViewId = (modelIdSuspect) => {
        if(!modelIdSuspect.match(/([a-z0-9]*)/)) {
            throw new Error('Expected view id, got '+modelIdSuspect);
        }
    };

    let lexed = [],
        i = 0;

    while(i < parts.length) {
        assertModelName(parts[i]);

        let token = {
            modelName: parts[i],
            itemId: null,
            mode: identify.VIEW_TABULAR,
            isDefaultMode: false
        };

        lexed.push(token);
        i++;

        if(i < parts.length) {
            switch (parts[i]) {
                case "views": {
                    assertViewId(parts[i + 1]);
                    token.isDefaultMode === true;
                    token.viewId = parts[i + 1];
                    return lexed;
                }
                default: {
                    assertItemId(parts[i]);
                    token.itemId = parts[i]; i++;
                    token.mode = token.itemId === identify.NEW_ITEM ? identify.VIEW_EDIT : identify.VIEW_VIEW;

                    if(i+1 === parts.length && modes.indexOf(parts[i]) > -1) {
                        token.mode = parts[i]; i++;
                    } else {
                        token.isDefaultMode = true;
                    }
                }
            }
        }
    }

    return lexed;
};

export default lexModelPathName;